import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { withRouter } from 'react-router-dom';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import * as actions from '../action';

function AppointmentLogs({
  data,
  // deleteAppointments,
  // getAppointmentsList,
  selectedTransaction,
  showTransaction,
  id,
  selected,
  updateAppointment,
  appointmentLogsList,
}) {
  const setModal = useContext(ModalContext);

  const handleUpdateAppointment = () => e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to update the appointment for ${_.get(
        data,
        'attributes.appointment_date'
      ) || 'this item'} / ${_.get(data, 'attributes.period') || ''} ?`,
      () => {
        updateAppointment(id, selected, () => {
          setModal({ isOpen: false });
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };
  // const handleEdit = (info) => (e) => {
  // 	e.preventDefault();
  // 	setModal({
  // 		isOpen: true,
  // 		content: <UpdateAppointmentModal appointmentData={info} />,
  // 		title: 'Update Appointment',
  // 		modalSize: 'modal-md',
  // 	});
  // };

  return (
    <div className="row p-3">
      <div className="col-md-12">
        <div className="card p-2">
          <div className="row">
            <div className="col-md-12 d-flex justify-content-between align-items-center">
              <div className="font-weight-bold text-center w100">
                Information
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 ">
              <div className="info-container p-4">
                <div className="row">
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Available Slots:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.available_slot') || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Consumed:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.consumed') || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Quota:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.quota') || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Date:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {moment(
                            _.get(data, 'attributes.appointment_date')
                          ).format('MM/DD/YYYY') || '---'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-6">
                        <span className="text-muted">Period:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.period') || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-12 d-flex justify-content-between align-items-center">
              <div className="font-weight-bold text-center w100">
                Appointment Logs
              </div>
            </div>
          </div>
          <div className="full-group">
            <div className="form-row">
              <table className="table table-borderless table-sm w-100">
                <thead>
                  <tr>
                    <td>
                      <div className="form-input-group">
                        <label className="full-label mb-0">
                          Appointment Date
                        </label>
                      </div>
                    </td>
                    <td>
                      <div className="form-input-group">
                        <label className="full-label mb-0">Period</label>
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {(appointmentLogsList || []).length > 0 ? (
                    (appointmentLogsList || []).map(item => (
                      <tr key={`${item.id}`}>
                        <td className="pb-0">
                          <p className="px-2 mb-0">
                            {_.get(
                              item,
                              'attributes.appointment_details.appointment_date'
                            ) || '--'}
                          </p>
                        </td>
                        <td className="pb-0">
                          <p className="px-2 mb-0">
                            {_.get(
                              item,
                              'attributes.appointment_details.period'
                            ) || '--'}
                          </p>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">
                        <div className="d-flex align-items-center justify-content-center h-100">
                          <div className="text-center mx-auto">
                            <p className="emp-title mb-0">
                              No Appointment Logs
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-5">
            <button
              type="button"
              className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  btn-sm font-weight-bold"
              disabled={_.isEmpty(selected)}
              onClick={handleUpdateAppointment(data)}
            >
              Update Appointment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

AppointmentLogs.defaultProps = {
  selected: '',
  id: '',
  selectedTransaction: '',
};

AppointmentLogs.propTypes = {
  // getAppointmentsList: PropTypes.instanceOf(Function).isRequired,
  updateAppointment: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  // deleteAppointments: PropTypes.instanceOf(Function).isRequired,
  appointmentLogsList: PropTypes.instanceOf(Array).isRequired,
  selected: PropTypes.string,
  id: PropTypes.number,
  selectedTransaction: PropTypes.number,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AppointmentLogs);
